import Vue from 'vue'
import TopWarningComponent from './index.vue'

import { debounce } from '@@/utils/utils'

const TopWarningConstructor = Vue.extend(TopWarningComponent)

// 每个类型都只挂载一个实例
let instances = new Map()

let zIndex = 3000
// 每次调用都要重置的参数
const defaultOptions = {
  type: 'warning', // waring, error
  closeAll: false, // 是否先关闭所有实例
  onOpen: null, // 打开的回调
  onClose: null, // 关闭的回调
}
// 初始化选项
const initOptions = (options) => {
  zIndex++
  if (options === undefined || options === null) {
    options = { content: '' }
  } else if (typeof options === 'string') {
    options = { content: options }
  }
  return { ...defaultOptions, ...options, zIndex }
}

/**
 * 顶部全宽提示组件
 * 
 * @param {object|string} options 
 * {
 *  type: 'warning', // waring, error
 *  content: '', // 提示语
 *  duration: 0, // 显示时间, 毫秒。设为 0 则不会自动关闭
 *  closeAll: false, // 是否先关闭所有实例
 *  onOpen: null, // 打开的回调
 *  onClose: null, // 关闭的回调
 * }
 * 
 * @returns vm
 */
const TopWarning = function (options) {
  options = initOptions(options)

  // 先关闭所有实例
  if (options.closeAll) {
    TopWarning.closeAll()
  }
  
  // 已有对应的实例
  if (instances.has(options.type)) {
    const currentInstanceVm = instances.get(options.type).vm
    Object.assign(currentInstanceVm.$data, options)
    currentInstanceVm.open()
    return currentInstanceVm
  }

  const instance = new TopWarningConstructor({ data: options }) //.$mount()
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)

  // 缓存实例引用
  instances.set(options.type, instance)

  // 组件销毁时清除实例
  instance.vm.$on('hook:destroyed', () => {
    instances.delete(options.type)
  })

  Vue.nextTick(() => {
    instance.vm.open()
    // 监听组件状态
    instance.vm.$on('isShowChange', (isShow) => {
      if (!isShow) {
        document.body.removeChild(instance.vm.$el)
        instance.vm.$destroy()
      }
    })
  })

  return instance.vm
}

// 提示样式
TopWarning.warning = options => {
  options = initOptions(options)
  options.type = 'warning'
  return TopWarning(options)
}

// 错误样式
TopWarning.error = options => {
  options = initOptions(options)
  options.type = 'error'
  return TopWarning(options)
}

// 合并字段提示
let fields = []
const debounceMergeFields = debounce((msgs) => {
  let tips = `您选择的【${[...new Set(msgs || [])].join("、")}】参数已发生变化，请仔细核对，谢谢！`
  TopWarning.warning(tips)
  fields = []
}, 500)
// 合并字段
TopWarning.mergeFields = field => {
  fields.push(field)
  debounceMergeFields(fields)
}

// 全部关闭
TopWarning.closeAll = () => {
  instances.forEach(instance => {
    instance.vm.close()
  })
}

export default TopWarning
